import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { LocaleApi } from "@/Modules/i18n/Model/Api";
import type { Locale } from "@/Modules/i18n/Model/Domain";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

const LocaleTransformer: TransformerExtended<Locale, LocaleApi> = {
  ...DefaultTransformerGenerator<Locale, LocaleApi>(),

  toDomain(localeApi: LocaleApi): Locale {
    return {
      locale: localeApi.locale,
      version: localeApi.version,
      translations: localeApi.translations,
    };
  },
};

export type LocaleTransformerType = TransformerExtended<Locale, LocaleApi>;

export default LocaleTransformer;
